// extracted by mini-css-extract-plugin
export var select = "_rz-0";